import { navLinks } from "@/components/feature/navLinks";
import { brandName, categories, contactInfo } from "@/mocks/home";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span
                className="w-9 h-9 rounded-md flex items-center justify-center text-lg font-heading font-black bg-background-50 text-primary-700"
                aria-hidden="true"
              >
                瓜
              </span>
              <span className="font-heading text-2xl font-black tracking-tight text-background-50">
                {brandName}
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-200/80 max-w-md">
              专注实时热点与深度爆料，追踪全网热门事件、内幕解析与网友热议精选，
              帮你快速掌握事件全貌，不错过任何精彩瞬间。
            </p>
            <p className="mt-6 text-xs font-label tracking-wide text-secondary-300">
              {contactInfo.slogan}
            </p>
          </div>

          <nav aria-label="页脚导航" className="lg:col-span-3">
            <h2 className="font-heading text-base font-bold text-background-50">浏览板块</h2>
            <ul className="mt-5 space-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-200/80 transition-colors hover:text-secondary-300 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="lg:col-span-2">
            <h2 className="font-heading text-base font-bold text-background-50">主题分类</h2>
            <ul className="mt-5 space-y-3">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <a
                    href="#topics"
                    className="text-sm text-background-200/80 transition-colors hover:text-secondary-300 cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h2 className="font-heading text-base font-bold text-background-50">联系我们</h2>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="text-sm text-background-200/80 transition-colors hover:text-secondary-300 cursor-pointer break-all"
                >
                  {contactInfo.email}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${contactInfo.business}`}
                  className="text-sm text-background-200/80 transition-colors hover:text-secondary-300 cursor-pointer break-all"
                >
                  {contactInfo.business}
                </a>
              </li>
              <li className="text-sm text-background-200/60">线索投稿 · 内容合作</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-200/60 text-center sm:text-left">
            © {year} {brandName} · 本站内容仅供信息阅读与讨论
          </p>
          <p className="text-xs text-background-200/60 flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-secondary-400" aria-hidden="true" />
            实时前线全天候更新
          </p>
        </div>
      </div>
    </footer>
  );
}